import { ImmerBasedPatchTypes, } from "@buildwithflux/models";
// TODO: do we need this to be stronger?  I don't think so.
export function isLegacyActionRecord(actionRec) {
    return !isPatchBasedActionRecord(actionRec);
}
export function isPatchBasedActionRecord(actionRec) {
    return ("type" in actionRec.actionChangeDiff && actionRec.actionChangeDiff.type === ImmerBasedPatchTypes.patchSequence);
}
export function isActionRecordWithActionArgs(actionRec) {
    return "actionArgs" in actionRec;
}
//# sourceMappingURL=predicates.js.map